import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface TrickSlotMachineProps {
  trickName: string;
  isDrawing: boolean;
  deckTricks: string[];
}

export const TrickSlotMachine: React.FC<TrickSlotMachineProps> = ({ trickName, isDrawing, deckTricks }) => {
  const [displayTrick, setDisplayTrick] = useState(trickName);
  
  useEffect(() => {
    if (isDrawing && deckTricks.length > 0) {
      let interval = setInterval(() => {
        setDisplayTrick(deckTricks[Math.floor(Math.random() * deckTricks.length)]);
      }, 80); // fast spin
      
      return () => clearInterval(interval);
    } else {
      setDisplayTrick(trickName);
    }
  }, [isDrawing, trickName, deckTricks]);

  const getFontSize = (text: string) => {
    const len = text.length;
    if (len > 30) return 'text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl';
    if (len > 20) return 'text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl';
    if (len > 12) return 'text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl';
    return 'text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl';
  };

  return (
    <div className="relative overflow-hidden w-full h-auto py-8 md:py-16 max-w-5xl flex items-center justify-center">
       <div className="w-full flex items-center justify-center text-center px-2 md:px-4 z-0">
         <AnimatePresence mode="popLayout">
           <motion.div
             key={displayTrick}
             initial={{ y: 30, opacity: 0, rotateX: -60 }}
             animate={{ y: 0, opacity: 1, rotateX: 0 }}
             exit={{ y: -30, opacity: 0, rotateX: 60 }}
             transition={{ duration: isDrawing ? 0.1 : 0.4, ease: "easeOut" }}
             className={`${getFontSize(displayTrick)} font-black font-rajdhani text-orange-400 drop-shadow-[0_0_15px_rgba(249,115,22,0.8)] uppercase tracking-widest break-words leading-tight w-full max-w-full whitespace-pre-wrap`}
           >
             {displayTrick}
           </motion.div>
         </AnimatePresence>
       </div>
    </div>
  );
};
